module.exports = __webpack_public_path__ + "static/cutter-cf6b2dca58e5848afb34e49b49d014c9.jpg";